import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const shareDetailsDataEditGridTemplate = htmlE`<div class="py-2 text-sm">
<div class="grid-column-gap is-align-items-center">
    <div>
        <span data-i18n-key="expires" class="has-text-weight-semibold is-pulled-right">${"expiresText"}</span>
    </div>
    <div class="is-flex gap-2">
        <div id="date-picker-parent">
            <input
                class="input is-inline modal-input"
                type="date"
                id="date-picker"
            />
        </div>
        <div id="time-picker-parent" class="mx-2">
            <input
                class="input is-inline modal-input"
                type="time"
                id="time-picker"
            />
        </div>
    </div>
</div>

<div class="grid-column-gap is-align-items-center mt-3">
    <div>
        <span data-i18n-key="remainingUses" class="has-text-weight-semibold is-pulled-right">${"remainingUsesText"}</span>
    </div>
    <div>
        <div class="select is-small">
        <select id="logins" class="primary-select modal-input">
            <option value="-1" data-i18n-key="unlimited">Unlimited</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
        </select>
        </div>
    </div>
</div>
</div>`;
